(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    

function kendallFormatMoney(cents, format) {
  if (typeof cents === 'string') { cents = cents.replace('.', ''); }
  cents = parseFloat(cents) || 0;

  function withDelimiters(number, precision, thousands, decimal) {
    precision = (typeof precision === 'undefined') ? 2 : precision;
    thousands = (typeof thousands === 'undefined') ? ',' : thousands;
    decimal = (typeof decimal === 'undefined') ? '.' : decimal;
    var value = (number / 100).toFixed(precision);
    var parts = value.split('.');
    var wholePart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsPart = parts[1] ? decimal + parts[1] : '';
    return wholePart + centsPart;
  }

  var placeholderMatch = (format || '{{amount}}').match(/\{\{\s*(\w+)\s*\}\}/);
  var key = placeholderMatch ? placeholderMatch[1] : 'amount';
  var formatted;

  switch (key) {
    case 'amount_no_decimals':
      formatted = withDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      formatted = withDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      formatted = withDelimiters(cents, 0, '.', ',');
      break;
    default:
      formatted = withDelimiters(cents, 2);
  }

  return (format || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, formatted);
}

document.addEventListener('DOMContentLoaded',function(){

  document.querySelectorAll('.product-kendall').forEach(function(root){

    var sectionId=root.getAttribute('data-section-id');
    var moneyFormat=root.getAttribute('data-money-format') || '{{amount}}';
    var isArabic=root.getAttribute('data-is-ar')==='true';


    /* =====================================================
       GALLERY
    ====================================================== */

    var mainSlides=root.querySelectorAll('.gallery-main-slide');
    var thumbs=root.querySelectorAll('.gallery-thumb');

    thumbs.forEach(function(thumb){

      thumb.addEventListener('click',function(){

        var idx=thumb.getAttribute('data-index');

        mainSlides.forEach(function(slide){

          slide.classList.toggle(
            'is-active',
            slide.getAttribute('data-index')===idx
          );

        });

        thumbs.forEach(function(t){

          t.classList.toggle(
            'is-active',
            t===thumb
          );

        });

      });

    });

    /* =====================================================
       QUANTITY
    ====================================================== */

    var qtyInput=root.querySelector('.qty-input');
    var qtyMinus=root.querySelector('[data-qty-minus]');
    var qtyPlus=root.querySelector('[data-qty-plus]');

    if(qtyMinus && qtyInput){

      qtyMinus.addEventListener('click',function(){

        var min=parseInt(qtyInput.min||1,10);
        var value=parseInt(qtyInput.value||min,10);

        qtyInput.value=Math.max(
          min,
          value-1
        );

      });

    }

    if(qtyPlus && qtyInput){

      qtyPlus.addEventListener('click',function(){

        var value=parseInt(qtyInput.value||1,10);

        qtyInput.value=Math.max(
          1,
          value+1
        );

      });

    }


    /* =====================================================
       VARIANTS
    ====================================================== */

    var variantsElement=document.getElementById(
      'variantsJson-'+sectionId
    );

    var optionGroups=root.querySelector(
      '#optionGroups-'+sectionId
    );

    var variantInput=root.querySelector(
      '#variantId-'+sectionId
    );

    var priceRow=root.querySelector(
      '#priceRow-'+sectionId
    );

    var addButton=root.querySelector(
      '#addCartBtn-'+sectionId
    );


    if(variantsElement && optionGroups && variantInput){

      var variants=[];

      try{

        variants=JSON.parse(
          variantsElement.textContent
        );

      }catch(error){

        console.error(
          'Kendall variants JSON error',
          error
        );

      }


      var selections=[];


      optionGroups
        .querySelectorAll('.option-values')
        .forEach(function(group,index){

          var selected=group.querySelector(
            '.option-pill.is-selected'
          );

          if(!selected){

            selected=group.querySelector(
              '.option-pill'
            );

          }

          selections[index]=selected
            ? selected.getAttribute('data-value')
            : null;

        });


      function findVariant(){

        return variants.find(function(variant){

          return selections.every(
            function(selection,index){

              if(
                selection===null ||
                selection===undefined
              ){
                return true;
              }

              var optionValue=variant[
                'option'+(index+1)
              ];

              return optionValue===selection;

            }
          );

        });

      }


      function updateVariant(){

        var variant=findVariant();

        if(!variant){
          return;
        }

        variantInput.value=variant.id;


        var fbtMainCheckbox=root.querySelector(
          '#fbtWrap-'+sectionId+' .pdp-fbt-item--main .pdp-fbt-checkbox'
        );

        if(fbtMainCheckbox){

          fbtMainCheckbox.setAttribute('data-variant-id',variant.id);
          fbtMainCheckbox.setAttribute('data-price',variant.price);

          if(typeof updateFbtTotal==='function'){

            updateFbtTotal();

          }

        }


        if(priceRow){

          if(
            variant.compare_at_price &&
            variant.compare_at_price>variant.price
          ){

            priceRow.innerHTML=
              '<span class="price-sale">'+
              variant.price_formatted+
              '</span>'+
              '<span class="price-compare">'+
              variant.compare_at_price_formatted+
              '</span>';

          }else{

            priceRow.innerHTML=
              '<span class="price">'+
              variant.price_formatted+
              '</span>';

          }

        }


        if(addButton){

          addButton.disabled=!variant.available;

          var textElement=addButton.querySelector('span');

          if(textElement){

            textElement.textContent=
              variant.available
              ? (isArabic
                  ? 'أضيفي إلى السلة'
                  : 'Add to Cart')
              : (isArabic
                  ? 'نفذت الكمية'
                  : 'Sold Out');

          }

        }

      }


      optionGroups
        .querySelectorAll('.option-values')
        .forEach(function(group,index){

          group
            .querySelectorAll('.option-pill')
            .forEach(function(pill){

              pill.addEventListener(
                'click',
                function(){

                  group
                    .querySelectorAll('.option-pill')
                    .forEach(function(p){

                      p.classList.remove(
                        'is-selected'
                      );

                    });

                  pill.classList.add(
                    'is-selected'
                  );

                  selections[index]=
                    pill.getAttribute(
                      'data-value'
                    );

                  updateVariant();

                }
              );

            });

        });


      updateVariant();

    }


    /* =====================================================
       FREQUENTLY BOUGHT TOGETHER
       Complementary products come straight from Shopify's own
       recommendation engine (intent=complementary) — no manual
       setup needed per product. Section stays hidden if Shopify
       has no complementary suggestions for this product.
    ====================================================== */

    var fbtWrap=root.querySelector(
      '#fbtWrap-'+sectionId
    );

    var fbtItems=root.querySelector(
      '#fbtItems-'+sectionId
    );

    var fbtTotal=root.querySelector(
      '#fbtTotal-'+sectionId
    );

    var fbtAddBtn=root.querySelector(
      '#fbtAddBtn-'+sectionId
    );

    var fbtAddBtnText=root.querySelector(
      '#fbtAddBtnText-'+sectionId
    );

    var fbtMsg=root.querySelector(
      '#fbtMsg-'+sectionId
    );


    function updateFbtTotal(){

      if(!fbtItems){
        return;
      }

      var checkboxes=fbtItems.querySelectorAll(
        '.pdp-fbt-checkbox'
      );

      var total=0;
      var count=0;

      checkboxes.forEach(function(checkbox){

        if(checkbox.checked){

          total+=parseFloat(
            checkbox.getAttribute('data-price')
          )||0;

          count++;

        }

      });

      if(fbtTotal){

        fbtTotal.textContent=
          kendallFormatMoney(total,moneyFormat);

      }

      if(fbtAddBtnText){

        fbtAddBtnText.textContent=
          isArabic
          ? ('إضافة '+count+' سلع إلى عربة التسوق')
          : ('Add '+count+' items to cart');

      }

      if(fbtAddBtn){

        fbtAddBtn.disabled=count===0;

      }

    }


    if(fbtWrap && fbtItems){

      var fbtUrl=
        window.Shopify.routes.root+
        'recommendations/products.json?product_id='+
        root.getAttribute('data-product-id')+
        '&limit=3&intent=complementary';


      fetch(fbtUrl)

        .then(function(response){

          return response.json();

        })

        .then(function(data){

          if(
            !data.products ||
            !data.products.length
          ){

            return;

          }


          data.products.forEach(function(p){

            var variant=null;

            if(p.variants && p.variants.length){

              variant=
                p.variants.find(
                  function(v){ return v.available; }
                ) || p.variants[0];

            }

            if(!variant){
              return;
            }


            var separator=
              document.createElement('span');

            separator.className='pdp-fbt-plus';
            separator.textContent='+';
            separator.setAttribute('aria-hidden','true');

            fbtItems.appendChild(separator);


            var item=
              document.createElement('div');

            item.className='pdp-fbt-item';


            var labelWrap=
              document.createElement('label');

            labelWrap.className=
              'pdp-fbt-checkbox-wrap';


            var checkbox=
              document.createElement('input');

            checkbox.type='checkbox';
            checkbox.className='pdp-fbt-checkbox';
            checkbox.checked=true;

            checkbox.setAttribute(
              'data-variant-id',
              variant.id
            );

            checkbox.setAttribute(
              'data-price',
              variant.price
            );

            checkbox.addEventListener(
              'change',
              updateFbtTotal
            );


            var box=
              document.createElement('span');

            box.className='pdp-fbt-checkbox-box';


            labelWrap.appendChild(checkbox);
            labelWrap.appendChild(box);


            var media=
              document.createElement('a');

            media.className='pdp-fbt-media';

            media.href=
              window.Shopify.routes.root+
              'products/'+p.handle;


            if(p.featured_image){

              var img=
                document.createElement('img');

              img.src=p.featured_image;
              img.alt=p.title;
              img.loading='lazy';

              media.appendChild(img);

            }


            var label=
              document.createElement('p');

            label.className='pdp-fbt-label';
            label.textContent=p.title;


            var price=
              document.createElement('span');

            price.className='pdp-fbt-price';

            price.textContent=
              kendallFormatMoney(
                variant.price,
                moneyFormat
              );


            item.appendChild(labelWrap);
            item.appendChild(media);
            item.appendChild(label);
            item.appendChild(price);

            fbtItems.appendChild(item);

          });


          fbtWrap.style.display='';

          updateFbtTotal();

        })

        .catch(function(){

          /* Keep the section hidden on failure */

        });

    }


    if(fbtAddBtn){

      fbtAddBtn.addEventListener(
        'click',
        function(){

          var checkedBoxes=
            fbtItems.querySelectorAll(
              '.pdp-fbt-checkbox:checked'
            );

          var items=[];

          checkedBoxes.forEach(function(checkbox){

            items.push({
              id:parseInt(
                checkbox.getAttribute('data-variant-id'),
                10
              ),
              quantity:1
            });

          });

          if(!items.length){
            return;
          }

          fbtAddBtn.disabled=true;


          fetch(
            window.Shopify.routes.root+'cart/add.js',
            {
              method:'POST',
              headers:{
                'Content-Type':'application/json',
                'Accept':'application/json'
              },
              body:JSON.stringify({ items:items })
            }
          )

          .then(function(response){

            return response.json();

          })

          .then(function(data){

            if(data.status){

              if(fbtMsg){

                fbtMsg.textContent=
                  data.description ||
                  (
                    isArabic
                    ? 'حدث خطأ أثناء إضافة المنتجات'
                    : 'Error adding items'
                  );

                fbtMsg.className=
                  'pdp-fbt-msg is-error';

              }

            }else{

              if(fbtMsg){

                fbtMsg.textContent=
                  isArabic
                  ? 'تمت إضافة المنتجات إلى السلة'
                  : 'Items added to cart';

                fbtMsg.className=
                  'pdp-fbt-msg is-success';

              }


              document
                .querySelectorAll(
                  '[data-cart-count], .cart-badge'
                )
                .forEach(function(badge){

                  var current=parseInt(
                    badge.textContent||'0',
                    10
                  )||0;

                  badge.textContent=
                    current+items.length;

                });

            }

          })

          .catch(function(){

            if(fbtMsg){

              fbtMsg.textContent=
                isArabic
                ? 'حدث خطأ، حاولي مرة أخرى'
                : 'Something went wrong';

              fbtMsg.className=
                'pdp-fbt-msg is-error';

            }

          })

          .finally(function(){

            fbtAddBtn.disabled=false;

          });

        }
      );

    }


    /* =====================================================
       AJAX ADD TO CART
    ====================================================== */

    var form=root.querySelector(
      'form.product-form'
    );

    var message=root.querySelector(
      '#addCartMsg-'+sectionId
    );


    if(form){

      form.addEventListener(
        'submit',
        function(event){

          event.preventDefault();

          var formData=new FormData(form);


          if(addButton){

            addButton.disabled=true;

          }


          fetch(
            window.Shopify.routes.root+'cart/add.js',
            {
              method:'POST',
              body:formData,
              headers:{
                'Accept':'application/json'
              }
            }
          )

          .then(function(response){

            return response.json();

          })

          .then(function(data){

            if(data.status){

              if(message){

                message.textContent=
                  data.description ||
                  (
                    isArabic
                    ? 'حدث خطأ أثناء إضافة المنتج'
                    : 'Error adding product'
                  );

                message.className=
                  'add-cart-msg is-error';

              }

            }else{

              if(message){

                message.textContent=
                  isArabic
                  ? 'تمت إضافة المنتج إلى السلة'
                  : 'Added to cart';

                message.className=
                  'add-cart-msg is-success';

              }


              document
                .querySelectorAll(
                  '[data-cart-count], .cart-badge'
                )
                .forEach(function(badge){

                  var current=parseInt(
                    badge.textContent||'0',
                    10
                  )||0;

                  var quantity=parseInt(
                    formData.get('quantity')||'1',
                    10
                  );

                  badge.textContent=
                    current+quantity;

                });

            }

          })

          .catch(function(){

            if(message){

              message.textContent=
                isArabic
                ? 'حدث خطأ، حاولي مرة أخرى'
                : 'Something went wrong';

              message.className=
                'add-cart-msg is-error';

            }

          })

          .finally(function(){

            if(addButton){

              addButton.disabled=false;

            }

          });

        }
      );

    }


    /* =====================================================
       SLIDERS
       Slider movement stays physically left/right for stable
       cross-browser behavior. Text/layout direction itself is
       controlled by the product wrapper locale.
    ====================================================== */

    root
      .querySelectorAll('[data-slider-prev]')
      .forEach(function(button){

        button.addEventListener(
          'click',
          function(){

            var id=button.getAttribute(
              'data-slider-prev'
            );

            var track=document.getElementById(id);

            if(track){

              track.scrollBy({
                left:-220,
                behavior:'smooth'
              });

            }

          }
        );

      });


    root
      .querySelectorAll('[data-slider-next]')
      .forEach(function(button){

        button.addEventListener(
          'click',
          function(){

            var id=button.getAttribute(
              'data-slider-next'
            );

            var track=document.getElementById(id);

            if(track){

              track.scrollBy({
                left:220,
                behavior:'smooth'
              });

            }

          }
        );

      });


    /* =====================================================
       RECOMMENDATIONS
    ====================================================== */

    var recWrap=root.querySelector(
      '#recWrap-'+sectionId
    );

    var recTrack=root.querySelector(
      '#recTrack-'+sectionId
    );


    if(recWrap && recTrack){

      var recommendationUrl=
        window.Shopify.routes.root+
        'recommendations/products.json?product_id='+
        root.getAttribute('data-product-id')+
        '&limit=8&intent=related';


      fetch(recommendationUrl)

        .then(function(response){

          return response.json();

        })

        .then(function(data){

          if(
            !data.products ||
            !data.products.length
          ){

            recWrap.style.display='none';

            return;

          }


          recTrack.innerHTML='';


          data.products.forEach(
            function(p){

              var card=document.createElement('a');

              card.href=
                window.Shopify.routes.root+
                'products/'+p.handle;

              card.className=
                'pdp-slide-card';


              var media=
                document.createElement('div');

              media.className=
                'pdp-slide-media';


              if(p.featured_image){

                var img=
                  document.createElement('img');

                img.src=
                  p.featured_image;

                img.alt=
                  p.title;

                img.loading='lazy';

                media.appendChild(img);

              }


              var title=
                document.createElement('h3');

              title.textContent=
                p.title;


              /* PRICE — Shopify's recommendations JSON
                 returns the price in cents (e.g. 20000),
                 same as any other Liquid price. Liquid's
                 `money` filter isn't available in plain
                 JS, so kendallFormatMoney() reproduces
                 exactly what that filter does, using the
                 shop's own money format (data-money-format
                 above), including a sale price if the
                 product has a compare_at_price. */

              var priceWrap=
                document.createElement('span');

              priceWrap.className=
                'pdp-slide-price-row';

              var hasSale=
                p.compare_at_price &&
                p.compare_at_price>p.price;

              var price=
                document.createElement('span');

              price.className=
                'pdp-slide-price';

              price.textContent=
                kendallFormatMoney(p.price, moneyFormat);

              priceWrap.appendChild(price);

              if(hasSale){

                var compare=
                  document.createElement('span');

                compare.className=
                  'pdp-slide-price-compare';

                compare.textContent=
                  kendallFormatMoney(p.compare_at_price, moneyFormat);

                priceWrap.appendChild(compare);

              }


              card.appendChild(media);
              card.appendChild(title);
              card.appendChild(priceWrap);

              recTrack.appendChild(card);

            }
          );

        })

        .catch(function(){

          recWrap.style.display='none';

        });

    }


    /* =====================================================
       INLINE SUGGESTED PRODUCTS
       Interleaves small "suggested product" cards inside the
       product description content itself, at spaced-out
       intervals (every 3rd element), the same way promotional
       blocks are dropped inside article/blog content. Runs
       independently of the Bundle Offer / Recommendations
       fallback above — it only needs the description block.
    ====================================================== */

    var descContent=
      root.querySelector('.pdp-description-content');

    if(descContent){

      /* Some product descriptions aren't flat <p>/<h2> tags
         directly under .pdp-description-content — content
         pasted in from other editors (or copied from AI-chat
         tools) can arrive wrapped in several levels of nested
         <div>s. Looking only at direct children would then see
         just "1 child" and never find anywhere to insert.
         Instead, walk the WHOLE subtree for real content blocks
         (headings/paragraphs/lists), wherever they sit. */
      var descBlockSelector=
        'p, h1, h2, h3, h4, h5, h6, ul, ol, blockquote';

      var descBlockCandidates=
        Array.prototype.slice.call(
          descContent.querySelectorAll(descBlockSelector)
        );

      /* Drop any candidate that's nested inside another
         candidate (e.g. a <p> inside a <blockquote>) so each
         real block is only counted once. */
      var descChildren=
        descBlockCandidates.filter(function(el){

          var parent=el.parentElement;

          while(parent && parent!==descContent){

            if(descBlockCandidates.indexOf(parent)!==-1){

              return false;

            }

            parent=parent.parentElement;

          }

          return true;

        });

      /* Space suggestions out evenly across whatever content is
         available instead of a fixed "every 3rd block" — that
         way a short description still gets one suggestion, and
         a long one gets several, spaced apart. */
      var inlineSuggestMaxCards=3;

      var inlineSuggestInterval=
        Math.max(
          2,
          Math.floor(
            descChildren.length/(inlineSuggestMaxCards+1)
          )
        );

      /* Not enough content to meaningfully space suggestions
         out through — skip quietly. */
      if(descChildren.length>=2){

        var inlineSuggestUrl=
          window.Shopify.routes.root+
          'recommendations/products.json?product_id='+
          root.getAttribute('data-product-id')+
          '&limit=6&intent=related';

        fetch(inlineSuggestUrl)

          .then(function(response){

            return response.json();

          })

          .then(function(data){

            if(
              !data.products ||
              !data.products.length
            ){

              return;

            }

            var suggestProducts=data.products;
            var suggestIndex=0;


            var inlineSuggestCartIconSvg=
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" '+
              'stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+
              '<circle cx="9" cy="21" r="1"></circle>'+
              '<circle cx="20" cy="21" r="1"></circle>'+
              '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 '+
              '2-1.61L23 6H6"></path>'+
              '</svg>';


            var buildInlineSuggestionCard=function(p){

              var variant=null;

              if(p.variants && p.variants.length){

                variant=
                  p.variants.find(
                    function(v){ return v.available; }
                  ) || p.variants[0];

              }


              var wrap=
                document.createElement('div');

              wrap.className=
                'pdp-inline-suggestion';


              var label=
                document.createElement('span');

              label.className=
                'pdp-inline-suggestion-label';

              label.textContent=
                isArabic ?
                  'قد يعجبك أيضًا' :
                  'You might also like';


              var productUrl=
                window.Shopify.routes.root+
                'products/'+p.handle;


              var body=
                document.createElement('div');

              body.className=
                'pdp-inline-suggestion-body';


              var media=
                document.createElement('a');

              media.className=
                'pdp-inline-suggestion-media';

              media.href=productUrl;

              if(p.featured_image){

                var img=
                  document.createElement('img');

                img.src=
                  p.featured_image;

                img.alt=
                  p.title;

                img.loading='lazy';

                media.appendChild(img);

              }


              var info=
                document.createElement('div');

              info.className=
                'pdp-inline-suggestion-info';

              var title=
                document.createElement('a');

              title.className=
                'pdp-inline-suggestion-title';

              title.href=productUrl;

              title.textContent=
                p.title;

              var price=
                document.createElement('span');

              price.className=
                'pdp-inline-suggestion-price';

              price.textContent=
                kendallFormatMoney(p.price, moneyFormat);

              info.appendChild(title);
              info.appendChild(price);


              var addBtn=
                document.createElement('button');

              addBtn.type='button';

              addBtn.className=
                'pdp-inline-suggestion-add';

              addBtn.setAttribute(
                'aria-label',
                (isArabic ? 'أضف ' : 'Add ')+
                p.title+
                (isArabic ? ' إلى السلة' : ' to cart')
              );


              var addIcon=
                document.createElement('span');

              addIcon.className=
                'pdp-inline-suggestion-add-icon';

              addIcon.setAttribute('aria-hidden','true');

              addIcon.innerHTML=
                inlineSuggestCartIconSvg;


              var addText=
                document.createElement('span');

              addText.className=
                'pdp-inline-suggestion-add-text';

              addText.textContent=
                isArabic ? 'أضف للسلة' : 'Add to cart';


              addBtn.appendChild(addIcon);
              addBtn.appendChild(addText);


              var msg=
                document.createElement('span');

              msg.className=
                'pdp-inline-suggestion-msg';


              if(variant){

                addBtn.setAttribute(
                  'data-variant-id',
                  variant.id
                );

                if(!variant.available){

                  addBtn.disabled=true;

                }

              }else{

                addBtn.disabled=true;

              }


              addBtn.addEventListener(
                'click',
                function(){

                  var variantId=
                    addBtn.getAttribute('data-variant-id');

                  if(!variantId){
                    return;
                  }

                  addBtn.disabled=true;

                  var originalText=
                    addText.textContent;

                  addText.textContent=
                    isArabic ? 'جارِ الإضافة...' : 'Adding...';


                  fetch(
                    window.Shopify.routes.root+'cart/add.js',
                    {
                      method:'POST',
                      headers:{
                        'Content-Type':'application/json',
                        'Accept':'application/json'
                      },
                      body:JSON.stringify({
                        id:parseInt(variantId,10),
                        quantity:1
                      })
                    }
                  )

                  .then(function(response){

                    return response.json();

                  })

                  .then(function(data){

                    if(data.status){

                      msg.textContent=
                        data.description ||
                        (
                          isArabic
                          ? 'حدث خطأ أثناء إضافة المنتج'
                          : 'Error adding item'
                        );

                      msg.className=
                        'pdp-inline-suggestion-msg is-error';

                      addText.textContent=
                        originalText;

                    }else{

                      msg.textContent=
                        isArabic
                        ? 'تمت إضافة المنتج إلى السلة'
                        : 'Added to cart';

                      msg.className=
                        'pdp-inline-suggestion-msg is-success';

                      addText.textContent=
                        isArabic ? 'تمت الإضافة' : 'Added';


                      document
                        .querySelectorAll(
                          '[data-cart-count], .cart-badge'
                        )
                        .forEach(function(badge){

                          var current=parseInt(
                            badge.textContent||'0',
                            10
                          )||0;

                          badge.textContent=
                            current+1;

                        });


                      setTimeout(function(){

                        addText.textContent=
                          originalText;

                      }, 2200);

                    }

                  })

                  .catch(function(){

                    msg.textContent=
                      isArabic
                      ? 'حدث خطأ، حاولي مرة أخرى'
                      : 'Something went wrong';

                    msg.className=
                      'pdp-inline-suggestion-msg is-error';

                    addText.textContent=
                      originalText;

                  })

                  .finally(function(){

                    addBtn.disabled=false;

                  });

                }
              );


              body.appendChild(media);
              body.appendChild(info);
              body.appendChild(addBtn);

              wrap.appendChild(label);
              wrap.appendChild(body);
              wrap.appendChild(msg);

              return wrap;

            };


            /* Walk the static snapshot (not the live children
               collection) and drop a card right after every
               Nth original element. Using the snapshot means
               inserted cards never get counted or re-walked. */
            for(
              var i=inlineSuggestInterval-1;
              i<descChildren.length;
              i+=inlineSuggestInterval
            ){

              if(
                suggestIndex>=suggestProducts.length ||
                suggestIndex>=inlineSuggestMaxCards
              ){

                break;

              }

              var anchorEl=descChildren[i];

              if(!anchorEl || !anchorEl.parentNode){

                continue;

              }

              var suggestionCard=
                buildInlineSuggestionCard(
                  suggestProducts[suggestIndex]
                );

              anchorEl.parentNode.insertBefore(
                suggestionCard,
                anchorEl.nextSibling
              );

              suggestIndex++;

            }

          })

          .catch(function(){});

      }

    }

  });

});


  } catch(e) { console.error(e); }
})();
})();
